import DrawerDividerItem from "@components/navbar/drawer/drawer_item_types/DrawerDividerItem";
import DrawerHeadingItem from "@components/navbar/drawer/drawer_item_types/DrawerHeadingItem";
import DrawerLinkItem from "@components/navbar/drawer/drawer_item_types/DrawerLinkItem";
import DrawerOperationItem from "@components/navbar/drawer/drawer_item_types/DrawerOperationItem";

const ITEM_TYPE_COMPONENTS = {
  divider: DrawerDividerItem,
  heading: DrawerHeadingItem,
  link: DrawerLinkItem,
  operation: DrawerOperationItem,
};

export default function DrawerItem(props) {
  const {
    type,
  } = props;

  const ItemComponent = ITEM_TYPE_COMPONENTS[type];
  if (!ItemComponent) return null;

  return (
    <ItemComponent {...props} />
  );
}
